import { Link } from "react-router";
import { Service } from "types/SalesNetworks";
import { APP_URL, getAppUrl } from "utils/defines";
import { removeLocalStorageTraceId } from "utils/helpers/localStorage";
import { getBackgroundImage, getIcons } from "utils/helpers/project";
import useTranslation from "utils/hooks/useTranslation";

export const ServiceSelectItem: React.FC<{
  service: Service;
  height?: string;
  length?: string;
}> = ({ service, height, length }) => {
  const { t } = useTranslation();
  const { code, label } = service;

  return (
    <Link
      to={getAppUrl(APP_URL.Etude.replace(":etudeType", code))}
      onClick={() => removeLocalStorageTraceId()}
    >
      <group
        key={code}
        data-height={height || "250"}
        data-length={length || ""}
        data-radius="15"
        data-background="highlight"
        data-radius-bottom-right="0"
        data-direction="column"
        data-justify="end"
        data-contain=""
        data-name="main-thumbnail-item"
        data-duration=".225"
        data-cursor="pointer"
      >
        <group
          data-position="absolute"
          data-background="main"
          data-height="fit"
        >
          <picture data-duration=".125">
            <img src={getBackgroundImage(code)} alt="" />
          </picture>
          <group
            data-position="absolute"
            data-background="linear-middark-bottom"
            data-height="fit"
          ></group>
          <group
            data-position="absolute"
            data-background="linear-dark-bottom"
            data-height="fit"
          ></group>
        </group>

        <group
          data-space="30"
          data-gap="10"
          data-name="main-thumbnail-item-panel"
          data-duration=".125"
        >
          <group
            data-background="white"
            data-length="50"
            data-height="50"
            data-radius="30"
            data-align="center"
            data-justify="center"
          >
            {getIcons(service.code)}
          </group>

          <group data-color="white">
            <text data-weight="600" data-text-size="xx-large">
              {t(label)}
            </text>
          </group>
        </group>
      </group>
    </Link>
  );
};
